import { ENV } from "@/config/env";
import { path } from "@/utils/common";

// ユーザ向けAPI（UnizoServiceStack: /{env}/unizo/apigw/apiEndpoint）
export const API_ENDPOINT = ENV.PRODUCT_API_ENDPOINT;
// 管理画面API（UnizoAdminServiceStack: /{env}/unizo/apigw/adminApiEndpoint）
export const ADMIN_API_ENDPOINT = ENV.ADMIN_API_ENDPOINT;

// Umeee 社内テナントの ID（全環境で固定・公開スラッグ）。一部の特殊権限は
// このテナントでのみ意味を持つため、付与UIの表示制御に使う。
// PRODUCT_DEV-811: 値の定義はサーバと共有する（当社スタッフを顧客テナントの
// 利用者一覧から外す判定が同じ値を見るため。二重管理にしない）。
export { UMEEE_TENANT_ID } from "@shared-domain/lib/tenant/vendorMembers";

export const AUTH_EXCHANGE = `${API_ENDPOINT}/auth/exchange-code`;
export const WHOAMI = `${API_ENDPOINT}/auth/whoami`;
export const AUTH_REFRESH = `${API_ENDPOINT}/auth/refresh`;
// PRODUCT_DEV-631: カレントテナント更新（テナント切替）。403 を画面内で扱うため
// shared-ui の callPatchCurrentTenant ではなく authFetch から直接叩く。
export const AUTH_ME = `${API_ENDPOINT}/auth/me`;
export const API_TENANT_USERS = `${API_ENDPOINT}/tenants/{tenantId}/users`;
export const API_MEETINGS = `${API_ENDPOINT}/meetings`;
// PRODUCT_DEV-613: 商談軽量索引（一覧/検索/顧客件数のクライアント即時処理用）
export const API_MEETINGS_LITE_INDEX = `${API_ENDPOINT}/meetings/lite-index`;
export const API_MEETINGS_MEETINGID = `${API_ENDPOINT}/meetings/{meetingId}`;
export const API_MEETINGS_MEETINGID_COPY_SUMMARY = `${API_ENDPOINT}/meetings/{meetingId}/copy-summary`;
// PRODUCT_DEV-531: Sansanコンタクト登録
export const API_MEETINGS_MEETINGID_SANSAN_REGISTER = `${API_ENDPOINT}/meetings/{meetingId}/sansan-register`;
export const API_MEETINGS_COMPLETION = `${API_ENDPOINT}/meetings/completion`;
export const API_MEETINGS_SEARCH = `${API_ENDPOINT}/meetings/search`;
export const API_PRESETS = `${API_ENDPOINT}/presets`;
export const API_PRESETS_PRESETID = `${API_ENDPOINT}/presets/{presetId}`;
export const API_PRESETS_SPEED_MODE_GUIDE = `${API_ENDPOINT}/presets/{presetId}/speed-mode-guide`;
// PRODUCT_DEV-684: プリセット AI 作成（発話 → 草案 + 確認質問の往復）
export const API_PRESETS_DRAFT_BUILD = `${API_ENDPOINT}/presets/draft-build`;
// PRODUCT_DEV-684(追補): プリセット音声修正（発話 → 編集操作 → 適用結果を返すだけ。DB は書かない）
export const API_PRESETS_VOICE_EDIT = `${API_ENDPOINT}/presets/{presetId}/voice-edit`;
export const API_COMPANIES = `${API_ENDPOINT}/companies`;
// PRODUCT_DEV-557: 全店顧客番号（企業マスタ systemIntegrationId）の直接更新
export const API_COMPANIES_COMPANYID = `${API_ENDPOINT}/companies/{companyId}`;
export const API_COMPANIES_SEARCH = `${API_ENDPOINT}/companies/search`;
export const API_COMPANIES_GBIZ_DETAIL = `${API_ENDPOINT}/companies/gbiz-detail`;
export const API_COMPANIES_SUGGEST_KANA = `${API_ENDPOINT}/companies/suggest-kana`;
// PRODUCT_DEV-212: 担当者類似判定（編集完了時の同一人物候補確認）
export const API_CONTACTS_MATCH_SUGGEST = `${API_ENDPOINT}/contacts/match-suggest`;
// PRODUCT_DEV-543: 個人(顧客マスタ)類似候補サジェスト（個人商談編集時の同一人物候補）
export const API_INDIVIDUALS_MATCH_SUGGEST = `${API_ENDPOINT}/individuals/match-suggest`;
export const OPENAI_REALTIME_SESSION = `${API_ENDPOINT}/openai/realtime/session`;
export const OPENAI_WHISPER_TRANSCRIBE = `${API_ENDPOINT}/openai/whisper/transcribe`;
export const API_MEETING_GROUPS = `${API_ENDPOINT}/meeting-groups`;
export const API_MEETING_GROUPS_GROUPID = `${API_ENDPOINT}/meeting-groups/{groupId}`;
export const API_MEETING_GROUPS_GENERATE_SUMMARY = `${API_ENDPOINT}/meeting-groups/{groupId}/generate-summary`;
// PRODUCT_DEV-572: 自分の所属部署（表示Preset/デフォPreset設定込み）
export const API_MY_DEPARTMENT = `${API_ENDPOINT}/my-department`;

// PRODUCT_DEV-583: マイ顧客（マイページ）
export const API_MY_CUSTOMERS = `${API_ENDPOINT}/my-customers`;
export const API_MY_CUSTOMERS_COMPANYID = `${API_ENDPOINT}/my-customers/{companyId}`;
// PRODUCT_DEV-583(R3): 主担当/サブ担当は廃止。マイ顧客は per-user membership
// (auto=自分が記録した / bookmarked=手動保存) に一本化。owner/sub エンドポイントは削除。
export const API_MY_CUSTOMERS_BOOKMARK = `${API_ENDPOINT}/my-customers/{companyId}/bookmark`;
export const API_MY_CUSTOMERS_RECORDING_CONTEXT = `${API_ENDPOINT}/my-customers/{companyId}/recording-context`;
// PRODUCT_DEV-583: マイ顧客から外す（自分の担当解除）
export const API_MY_CUSTOMERS_ASSIGNMENT = `${API_ENDPOINT}/my-customers/{companyId}/assignment`;
export const API_MY_CUSTOMERS_HANDOVER = `${API_ENDPOINT}/my-customers/handover`;
export const API_MY_CUSTOMERS_TODAY_COPY = `${API_ENDPOINT}/my-customers/today-copy`;
// PRODUCT_DEV-583: 在籍ユーザー一覧（サブ担当/引き継ぎ先ピッカー）。既存 API_TENANT_USERS
// (/tenants/{tenantId}/users) とは別の新エンドポイント。
export const API_TENANT_USERS_LIST = `${API_ENDPOINT}/tenant-users`;

// PRODUCT_DEV-424: メモ / ToDo API
export const API_MEMOS = `${API_ENDPOINT}/memos`;
export const API_MEMOS_MEMOID = `${API_ENDPOINT}/memos/{memoId}`;
// PRODUCT_DEV-502 ③: メモのゴミ箱(一覧/復元)
export const API_MEMOS_TRASH = `${API_ENDPOINT}/memos/trash`;
export const API_MEMOS_MEMOID_RESTORE = `${API_ENDPOINT}/memos/{memoId}/restore`;
export const API_TODOS = `${API_ENDPOINT}/todos`;
export const API_TODOS_TODOID = `${API_ENDPOINT}/todos/{todoId}`;
// PRODUCT_DEV-424 Phase 2: 音声メモ
export const API_MEMOS_AUDIO_UPLOAD_URL = `${API_ENDPOINT}/memos/audio-upload-url`;
export const API_MEMOS_MEMOID_TRANSCRIBE = `${API_ENDPOINT}/memos/{memoId}/transcribe`;
// PRODUCT_DEV-501: AI ToDo 候補の再生成
export const API_MEMOS_MEMOID_REGENERATE_TODOS = `${API_ENDPOINT}/memos/{memoId}/regenerate-todos`;
// PRODUCT_DEV-424 Phase 3: AI ToDo 候補一括作成
export const API_TODOS_BATCH_CREATE = `${API_ENDPOINT}/todos/batch-create`;

// PRODUCT_DEV-586: 議事録（録音タブ / 長尺プログレッシブ文字起こし）
export const API_MINUTES = `${API_ENDPOINT}/minutes`;
export const API_MINUTES_MINUTESID = `${API_ENDPOINT}/minutes/{minutesId}`;
export const API_MINUTES_TRASH = `${API_ENDPOINT}/minutes/trash`;
export const API_MINUTES_MINUTESID_RESTORE = `${API_ENDPOINT}/minutes/{minutesId}/restore`;
export const API_MINUTES_UPLOAD_URL = `${API_ENDPOINT}/minutes/upload-url`;
export const API_MINUTES_MINUTESID_CHUNK_UPLOAD_URL = `${API_ENDPOINT}/minutes/{minutesId}/chunk-upload-url`;
export const API_MINUTES_MINUTESID_FINALIZE = `${API_ENDPOINT}/minutes/{minutesId}/finalize`;
export const API_MINUTES_MINUTESID_TRANSCRIPT = `${API_ENDPOINT}/minutes/{minutesId}/transcript`;
export const API_MINUTES_MINUTESID_TRANSCRIPT_URL = `${API_ENDPOINT}/minutes/{minutesId}/transcript-url`;
// PRODUCT_DEV-603: 生（未クリーン）文字起こしの署名GET URL（admin限定）
export const API_MINUTES_MINUTESID_TRANSCRIPT_RAW = `${API_ENDPOINT}/minutes/{minutesId}/transcript-raw`;
export const API_MINUTES_MINUTESID_HEARTBEAT = `${API_ENDPOINT}/minutes/{minutesId}/heartbeat`;

/**
 * 管理画面API URL（ADMIN_API_ENDPOINT = 独立したAPI Gateway）
 */
export const API_ADMIN_USERS = `${ADMIN_API_ENDPOINT}/admin/users`;
export const API_ADMIN_USERS_USERID = `${ADMIN_API_ENDPOINT}/admin/users/{userId}`;
export const API_ADMIN_USERS_USERID_RESET_PASSWORD = `${ADMIN_API_ENDPOINT}/admin/users/{userId}/reset-password`;

// 顧客マスタ管理API
export const API_ADMIN_COMPANIES = `${ADMIN_API_ENDPOINT}/admin/companies`;
export const API_ADMIN_COMPANIES_COMPANYID = `${ADMIN_API_ENDPOINT}/admin/companies/{companyId}`;
// PRODUCT_DEV-420: CSVアップロード（admin only）
export const API_ADMIN_COMPANIES_UPLOAD_PREVIEW = `${ADMIN_API_ENDPOINT}/admin/companies/upload/preview`;
export const API_ADMIN_COMPANIES_UPLOAD_EXECUTE = `${ADMIN_API_ENDPOINT}/admin/companies/upload/execute`;
export const API_ADMIN_COMPANIES_REPORT = `${ADMIN_API_ENDPOINT}/admin/companies/{companyId}/report`;
export const API_ADMIN_COMPANIES_REPORT_ENTRIES = `${ADMIN_API_ENDPOINT}/admin/companies/{companyId}/report/entries`;
export const API_ADMIN_COMPANIES_REPORT_ENTRY = `${ADMIN_API_ENDPOINT}/admin/companies/{companyId}/report/entries/{entryId}`;
export const API_ADMIN_REPORT_CONFIG = `${ADMIN_API_ENDPOINT}/admin/report/config`;
export const API_ADMIN_COMPANIES_REPORT_CONFIG = `${ADMIN_API_ENDPOINT}/admin/companies/{companyId}/report/config`;

// PRODUCT_DEV-640: データ出力（商談結果DL）
export const API_ADMIN_DATA_EXPORT_COLUMNS = `${ADMIN_API_ENDPOINT}/admin/data-export/datasets/{datasetId}/columns`;
export const API_ADMIN_DATA_EXPORT_PREVIEW = `${ADMIN_API_ENDPOINT}/admin/data-export/preview`;
export const API_ADMIN_DATA_EXPORT_RUN = `${ADMIN_API_ENDPOINT}/admin/data-export/run`;
export const API_ADMIN_DATA_EXPORT_VIEWS = `${ADMIN_API_ENDPOINT}/admin/data-export/views`;
export const API_ADMIN_DATA_EXPORT_VIEWS_VIEWID = `${ADMIN_API_ENDPOINT}/admin/data-export/views/{viewId}`;

// テナント辞書管理API（ユーザ向け読み取りはAPI_ENDPOINT、管理はADMIN_API_ENDPOINT）
export const API_DICTIONARIES = `${API_ENDPOINT}/dictionaries`;
export const API_ADMIN_DICTIONARIES = `${ADMIN_API_ENDPOINT}/admin/dictionaries`;
export const API_ADMIN_DICTIONARIES_DICTIONARYID = `${ADMIN_API_ENDPOINT}/admin/dictionaries/{dictionaryId}`;

// プリセット管理API
export const API_ADMIN_PRESETS = `${ADMIN_API_ENDPOINT}/admin/presets`;
export const API_ADMIN_PRESETS_PRESETID = `${ADMIN_API_ENDPOINT}/admin/presets/{presetId}`;

// リアルタイムAPI設定（ユーザ向け読み取りはAPI_ENDPOINT、管理はADMIN_API_ENDPOINT）
export const API_REALTIME_CONFIGS = `${API_ENDPOINT}/realtime-configs`;
export const API_ADMIN_REALTIME_CONFIGS = `${ADMIN_API_ENDPOINT}/admin/realtime-configs`;
export const API_ADMIN_REALTIME_CONFIGS_CONFIGID = `${ADMIN_API_ENDPOINT}/admin/realtime-configs/{configId}`;

// テナント設定API
export const API_ADMIN_TENANT_SETTINGS = `${ADMIN_API_ENDPOINT}/admin/tenant-settings`;

// PRODUCT_DEV-572: 部署管理API
export const API_ADMIN_DEPARTMENTS = `${ADMIN_API_ENDPOINT}/admin/departments`;
export const API_ADMIN_DEPARTMENTS_DEPTID = `${ADMIN_API_ENDPOINT}/admin/departments/{deptId}`;
export const API_ADMIN_USER_DEPARTMENTS = `${ADMIN_API_ENDPOINT}/admin/user-departments`;
export const API_ADMIN_USER_DEPARTMENTS_USERID = `${ADMIN_API_ENDPOINT}/admin/user-departments/{userId}`;

// ONPプロンプト設定・グローバル辞書（Admin管理テーブル読み取り専用）
export const API_ONP_PROMPT_SETTINGS = `${API_ENDPOINT}/onp-prompt-settings`;
export const API_GLOBAL_DICTIONARY = `${API_ENDPOINT}/global-dictionary`;
export const API_OPERATOR_ANNOUNCEMENTS = `${API_ENDPOINT}/operator-announcements`;
export const API_OPERATOR_ANNOUNCEMENT_READS = `${API_ENDPOINT}/operator-announcement-reads`;
// PRODUCT_DEV-466: 共有ファイル ダウンロードURL取得 (お知らせ添付ファイル等)
export const API_SHARED_FILES_FILEID_DOWNLOAD_URL = `${API_ENDPOINT}/shared-files/{fileId}/download-url`;
export const API_SPEED_RECORDING_UPLOAD_URL = `${API_ENDPOINT}/speed-recording/upload-url`;
export const API_SPEED_RECORDING_SUBMIT = `${API_ENDPOINT}/speed-recording/submit`;
// PRODUCT_DEV-514: 対話モード音声の故障解析用アップロードURL取得
export const API_RECORDING_AUDIO_UPLOAD_URL = `${API_ENDPOINT}/recording/audio-upload-url`;

/**
 * ルートパス
 */
export const ROUTE_TOP = path("/");
export const ROUTE_GUIDE = path("/guide");
export const ROUTE_MEMO = path("/memo");
export const ROUTE_ANNOUNCEMENTS = path("/announcements");
export const ROUTE_COMPANIES = path("/companies");
// PRODUCT_DEV-583: マイ顧客（マイページ）
export const ROUTE_MY_CUSTOMERS = path("/my-customers");
export const ROUTE_MY_CUSTOMERS_DETAIL = path("/my-customers/:companyId");
export const ROUTE_MY_CUSTOMERS_EDIT = path("/my-customers/:companyId/edit");
export const ROUTE_MY_CUSTOMERS_HANDOVER = path("/my-customers/handover");
// PRODUCT_DEV-419 follow-up: メンバー向け辞書ルート (admin/dictionaries と同じコンポーネントを共有)
export const ROUTE_DICTIONARIES = path("/dictionaries");
export const ROUTE_ADMIN = path("/admin");
export const ROUTE_ADMIN_USERS = path("/admin/users");
export const ROUTE_ADMIN_TENANT_SETTINGS = path("/admin/tenant-settings");
export const ROUTE_ADMIN_PRESETS = path("/admin/presets");
export const ROUTE_ADMIN_COMPANIES = path("/admin/companies");
// PRODUCT_DEV-622: 顧客レポートは管理画面の外に置く（一般メンバーも使うため、
// 左の管理メニューを持たない単体ページとして別ウィンドウで開く）。
// 旧 /admin/companies/:companyId/report は既存リンク救済のためリダイレクトだけ残す。
export const ROUTE_COMPANY_REPORT = path("/customer-report/:companyId");
export const ROUTE_ADMIN_COMPANY_REPORT = path("/admin/companies/:companyId/report");
export const ROUTE_ADMIN_DICTIONARIES = path("/admin/dictionaries");
export const ROUTE_ADMIN_REALTIME_CONFIGS = path("/admin/realtime-configs");
// PRODUCT_DEV-572: 部署管理
export const ROUTE_ADMIN_DEPARTMENTS = path("/admin/departments");
// PRODUCT_DEV-640: データ出力（sysadmin メニューから遷移）
export const ROUTE_ADMIN_DATA_EXPORT = path("/admin/data-export");
export const ROUTE_NOTIFICATIONS = path("/notifications");
export const ROUTE_TRASH = path("/trash");
export const ROUTE_403 = path("/403");
export const ROUTE_RECORDING = path("/recording");
/** 自由記録モードの録音画面（対話モードは `ROUTE_RECORDING`）。 */
export const ROUTE_SPEED_RECORDING = path("/speed-recording");
// PRODUCT_DEV-586: 議事録
export const ROUTE_MINUTES_RECORDING = path("/minutes/recording");
export const ROUTE_MINUTES_DETAIL = path("/minutes/:minutesId");
export const ROUTE_COPY_RECORD_SETUP = path("/copy-record-setup");
export const ROUTE_SETTINGS = path("/settings");
export const ROUTE_CHAT = path("/chat");
// PRODUCT_DEV-484: エイリアスログイン用ショートカット インストール案内ページ
export const ROUTE_SHORTCUT_INSTALL = path("/shortcut-install");
// PRODUCT_DEV-635: 問い合わせ
export const ROUTE_INQUIRIES = path("/inquiries");
export const ROUTE_INQUIRIES_NEW = path("/inquiries/new");
export const ROUTE_INQUIRIES_DETAIL = path("/inquiries/:inquiryId");
// PRODUCT_DEV-690: 問い合わせ前の AI Q&A（flag inquiryQa。OFF は一覧へ redirect）
export const ROUTE_INQUIRIES_QA = path("/inquiries/qa");

// PRODUCT_DEV-673: マイページ（活動サマリ）。**Unizo に導線は作らず URL 直打ちで到達する**ため、
// ボトムナビ・メニュー・管理サイドバーのどこにも項目を足さないこと。
export const ROUTE_MYPAGE = path("/mypage");
export const ROUTE_MYPAGE_SUMMARY = path("/mypage/summary");
export const ROUTE_MYPAGE_ADMIN = path("/mypage/admin");
export const ROUTE_MYPAGE_ARCHIVE = path("/mypage/archive");
export const ROUTE_MYPAGE_REPORT = path("/mypage/reports/:period/:periodKey");

// PRODUCT_DEV-675: 日程調整
export const ROUTE_MYPAGE_SCHEDULING = path("/mypage/scheduling");
export const ROUTE_MYPAGE_SCHEDULING_NEW = path("/mypage/scheduling/new");
export const ROUTE_MYPAGE_SCHEDULING_DETAIL = path(
  "/mypage/scheduling/:scheduleId",
);
export const ROUTE_MYPAGE_SCHEDULING_RESCHEDULE = path(
  "/mypage/scheduling/:scheduleId/reschedule",
);
/**
 * 確定前の候補日時の編集。**確定後は `reschedule` の担当**で、こちらはサーバが 409 を返す
 * （確定枠が候補から消えると、相手が確定日時をアプリ上で確認できなくなるため）。
 */
export const ROUTE_MYPAGE_SCHEDULING_EDIT = path(
  "/mypage/scheduling/:scheduleId/edit",
);
/**
 * 相手がログインせずに開く回答画面。**rootLoader の外に置く唯一のルート**。
 * root の children に入れると rootLoader が走り、未ログインの相手が Portal SSO へ
 * 飛ばされる（「相手がログインせずに応答できる」がこの機能の価値そのもの）。
 * 共有コアの `buildShareUrl` が組む `{origin}/s/{token}` と一致させること。
 */
export const ROUTE_GUEST_SCHEDULING = path("/s/:token");

/**
 * エラーメッセージ
 */
export const ERROR_NO_PERMISSION =
  "このページにアクセスする権限がありません。管理者にお問い合わせください。";
export const ERROR_ACCESS_LOGGED = "不正なアクセスはすべて記録されています。";
export const ERROR_CREATE_USER_FAILED = "Failed to create user";
export const ERROR_DELETE_USER_FAILED = "Failed to delete user";

/**
 * 商談バッチ移動・グループ削除
 */
export const API_MEETINGS_BATCH_MOVE = `${API_ENDPOINT}/meetings/batch-move`;
export const API_MEETINGS_BATCH_PATCH = `${API_ENDPOINT}/meetings/batch-patch`;
export const API_MEETINGS_BATCH_DELETE = `${API_ENDPOINT}/meetings/batch-delete`;
export const API_MEETING_GROUPS_GROUPID_DELETE = `${API_ENDPOINT}/meeting-groups/{groupId}`;
export const API_MEETINGS_TRASH = `${API_ENDPOINT}/meetings/trash`;
export const API_MEETINGS_TRASH_RESTORE = `${API_ENDPOINT}/meetings/trash/restore`;
export const API_FAVORITES = `${API_ENDPOINT}/favorites`;
export const API_FAVORITES_MEETINGID = `${API_ENDPOINT}/favorites/{meetingId}`;
export const API_GROUP_FAVORITES = `${API_ENDPOINT}/group-favorites`;
export const API_GROUP_FAVORITES_GROUPID = `${API_ENDPOINT}/group-favorites/{groupId}`;
export const API_VIEW_HISTORY = `${API_ENDPOINT}/view-history`;
export const API_VIEW_HISTORY_MEETINGID = `${API_ENDPOINT}/view-history/{meetingId}`;

// 問い合わせ（PRODUCT_DEV-635）
export const API_INQUIRIES = `${API_ENDPOINT}/inquiries`;
export const API_INQUIRIES_INQUIRYID = `${API_ENDPOINT}/inquiries/{inquiryId}`;
// 問い合わせ前の AI Q&A（PRODUCT_DEV-690。DDB に保存しない同期エンドポイント）
export const API_INQUIRIES_QA = `${API_ENDPOINT}/inquiries/qa`;

// アプリ内通知（PRODUCT_DEV-293）
export const API_NOTIFICATIONS = `${API_ENDPOINT}/notification`;
export const API_NOTIFICATIONS_UNREAD_COUNT = `${API_ENDPOINT}/notification/unread-count`;
export const API_NOTIFICATION_READ = `${API_ENDPOINT}/notification`;
export const API_NOTIFICATION_READ_ALL = `${API_ENDPOINT}/notification/read-all`;
export const API_NOTIFICATION_SETTINGS = `${API_ENDPOINT}/notification/settings`;

// 対話キャラクター 個人設定（PRODUCT_DEV-638）
// PRODUCT_DEV-659 で女性固定にしたため **現在フロントからの呼び出しは無い**。
// API/DDB を切り戻し用に残置しているのに合わせて定義も残す。
export const API_DIALOGUE_CHARACTER_SETTING = `${API_ENDPOINT}/user-settings/dialogue-character`;

// PRODUCT_DEV-673: 活動サマリ / 日報・週報・月報
export const API_ACTIVITY_SUMMARY = `${API_ENDPOINT}/activity-summary`;
// PRODUCT_DEV-675: マイページ「今日の予定」の材料（次回アポが今日の商談）。自分のぶんのみ。
export const API_ACTIVITY_SUMMARY_TODAY = `${API_ENDPOINT}/activity-summary/today`;
export const API_ACTIVITY_SUMMARY_ARCHIVE = `${API_ENDPOINT}/activity-summary/archive`;
export const API_ACTIVITY_SUMMARY_DETAIL = `${API_ENDPOINT}/activity-summary/{period}/{periodKey}`;
export const API_ACTIVITY_SUMMARY_GENERATE = `${API_ENDPOINT}/activity-summary/{period}/{periodKey}/generate`;
export const API_ACTIVITY_SUMMARY_COMMENTS = `${API_ENDPOINT}/activity-summary/comments`;
export const API_USER_PREFERENCES = `${API_ENDPOINT}/user-preferences`;

// PRODUCT_DEV-675: 日程調整
export const API_SCHEDULING = `${API_ENDPOINT}/scheduling`;
export const API_SCHEDULING_SCHEDULEID = `${API_ENDPOINT}/scheduling/{scheduleId}`;
export const API_SCHEDULING_PREVIEW_MAIL = `${API_ENDPOINT}/scheduling/{scheduleId}/preview-mail`;
export const API_SCHEDULING_INVITES = `${API_ENDPOINT}/scheduling/{scheduleId}/invites`;
export const API_SCHEDULING_INVITE = `${API_ENDPOINT}/scheduling/{scheduleId}/invites/{inviteId}`;
export const API_SCHEDULING_INVITE_RESEND = `${API_ENDPOINT}/scheduling/{scheduleId}/invites/{inviteId}/resend`;
export const API_SCHEDULING_CONFIRM = `${API_ENDPOINT}/scheduling/{scheduleId}/confirm`;
// PRODUCT_DEV-675: 確定後の操作。どちらも相手にメールと .ics が飛ぶ不可逆操作。
export const API_SCHEDULING_RESCHEDULE = `${API_ENDPOINT}/scheduling/{scheduleId}/reschedule`;
export const API_SCHEDULING_CANCEL = `${API_ENDPOINT}/scheduling/{scheduleId}/cancel`;
/**
 * PRODUCT_DEV-775: リンクの追加発行（メールは送らない・古いリンクも生きたまま）。
 * メールアドレスを持たない相手へ SMS・LINE・対面でリンクを渡すための口。
 * ⚠ `..._RESEND` と取り違えないこと。あちらは古いリンクを失効させてメールを送る。
 */
export const API_SCHEDULING_INVITE_SHARE_LINK = `${API_ENDPOINT}/scheduling/{scheduleId}/invites/{inviteId}/share-link`;
/**
 * PRODUCT_DEV-675 8/28: 確定を解いて候補を出し直し、相手に ○ × で聞き直す。
 * ⚠ `..._RESCHEDULE` と取り違えないこと。あちらは確定したまま日時を差し替える。
 * こちらは「回答待ち」へ戻すので、一覧でも確定済みから外れる。
 */
export const API_SCHEDULING_REOPEN = `${API_ENDPOINT}/scheduling/{scheduleId}/reopen`;
/**
 * 相手（未認証）が叩く 2 本。**認証ヘッダも tenantId も付けない**専用クライアント
 * (`lib/scheduling/guestClient.ts`) からのみ呼ぶこと。
 */
export const API_PUBLIC_SCHEDULING = `${API_ENDPOINT}/public/scheduling/{token}`;
export const API_PUBLIC_SCHEDULING_ANSWER = `${API_ENDPOINT}/public/scheduling/{token}/answer`;
/**
 * 確定後に相手が「この日程は難しい」と伝える口 (PRODUCT_DEV-675 実機フィードバック)。
 * メールを持たない宛先には返信という手段が無いので、画面側にこの導線が要る。
 */
export const API_PUBLIC_SCHEDULING_DECLINE = `${API_ENDPOINT}/public/scheduling/{token}/decline`;
// PRODUCT_DEV-698: 部のまとめ音声の署名 URL（S3 キーそのものは返らない）。
export const API_ACTIVITY_SUMMARY_TEAM_AUDIO = `${API_ENDPOINT}/activity-summary/team-audio`;
// PRODUCT_DEV-673 / PRODUCT_DEV-698: テナント既定と部署ごとの配信設定。
// ⚠ **`ADMIN_API_ENDPOINT` 側**。実体は `unizo-admin-service-stack.ts` の
// `adminTenantPreferencesRouter` に載っていて、`/admin/*` は他も全部こちらの API Gateway。
// 一度 `API_ENDPOINT` で書いてしまい、dev で「設定の読み込みに失敗しました」になった
// （商品側 API には該当ルートが無いので 404。認可の問題に見えるが host 違い）。
export const API_ADMIN_TENANT_PREFERENCES = `${ADMIN_API_ENDPOINT}/admin/tenant-preferences`;
export const API_ADMIN_DEPARTMENT_PREFERENCES = `${ADMIN_API_ENDPOINT}/admin/department-preferences`;
export const API_ADMIN_DEPARTMENT_PREFERENCES_DEPTID = `${ADMIN_API_ENDPOINT}/admin/department-preferences/{deptId}`;

// Push通知API（PRODUCT_DEV-296: Notification API Gateway）
export const NOTIFICATION_API_ENDPOINT = ENV.NOTIFICATION_API_ENDPOINT;
export const API_PUSH_SUBSCRIBE = `${NOTIFICATION_API_ENDPOINT}/push/subscribe`;
export const API_PUSH_VAPID_KEY = `${NOTIFICATION_API_ENDPOINT}/push/vapid-key`;

// Push通知テストイベント（Unizo API Gateway - 業務Lambda模擬）
export const API_PUSH_TEST_EVENT = `${API_ENDPOINT}/push/test-event`;
